import { topicTags } from '@/mocks/home';
import Reveal from '@/components/feature/Reveal';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function TopicWall() {
  return (
    <section id="topics" className="border-b border-background-200 bg-background-50 py-20 md:py-28">
      <div className="w-full px-4 md:px-6">
        <Reveal>
          <SectionHeading
            index="01"
            eyebrow="Topic Wall"
            title="话题墙：按热度排列的追更标签"
            desc="所有条目先归入话题，再进入合集。点选任意标签即可跳转时间线，查看该话题下最新的黑料反差爆料批次与归档进度。"
          />
        </Reveal>

        <Reveal delay={120}>
          <div className="mt-12 flex flex-wrap gap-2 md:gap-3">
            {topicTags.map((tag) => (
              <a
                key={tag.name}
                href="#timeline"
                className="group inline-flex items-center gap-2 rounded-full border border-background-300 bg-background-100 px-4 py-2.5 transition-colors hover:border-primary-400 hover:bg-primary-50"
              >
                <span className="text-sm text-foreground-800 transition-colors group-hover:text-primary-700">
                  {tag.name}
                </span>
                <span className="font-label text-[11px] text-foreground-500">{tag.count}</span>
              </a>
            ))}
          </div>
        </Reveal>

        <Reveal delay={200}>
          <div className="mt-12 flex flex-col gap-4 rounded-lg border border-background-200 bg-background-100 p-6 md:flex-row md:items-center md:justify-between md:p-7">
            <div className="flex items-start gap-4">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-secondary-500 text-background-50">
                <i className="ri-book-marked-line text-lg" />
              </span>
              <div>
                <p className="font-heading text-base font-bold text-foreground-950">不知道怎么开始看？</p>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">
                  从「合集索引」入手最快，每册都按话题整理了完整的线索与出处。
                </p>
              </div>
            </div>
            <a
              href="#collections"
              className="inline-flex h-10 shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              查看合集索引
              <i className="ri-arrow-right-line" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}